import { render, staticRenderFns } from "./ListSimpleStandard.vue?vue&type=template&id=f6ddceba&"
import script from "./ListSimpleStandard.vue?vue&type=script&lang=js&"
export * from "./ListSimpleStandard.vue?vue&type=script&lang=js&"
import style0 from "./ListSimpleStandard.vue?vue&type=style&index=0&id=f6ddceba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports